<script>

	function makeShareUrl (baseUrl, params = {}) {
		const url = new URL(baseUrl)
		for(const param in params) {
			url.searchParams.set(param, params[param])
		}
		return url.href
	}

	export default {
		methods: {
			open (href) {
				window.open(href, 'ss_share', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600')
			},
			openFacebook () {
				const href = makeShareUrl(`https://www.facebook.com/sharer/sharer.php`, {
					u: window.location.href
				})
				this.open(href)
			},
			openTwitter () {
				const href = makeShareUrl(`https://twitter.com/intent/tweet`, {
					text: document.title,
					url: window.location.href
				})
				this.open(href)
			}
		},
		render () {
			const { $style } = this
			const sources = [
				{
					name: 'facebook',
					method: this.openFacebook
				},
				{
					name: 'twitter',
					method: this.openTwitter
				}
			]
			return (
				<div class={$style.share}>
					{sources.map((source) => {
						const onClickHandler = (e) => {
							e.preventDefault()
							source.method()
						}
						return (
							<a href="#" onClick={onClickHandler} class={$style.link} key={source.name}>
								<sprite name={source.name} class={$style.sprite} />
							</a>
						)
					})}
				</div>
			)
		}
	}
</script>

<style lang="scss" module>
	.share {
		display:flex;
	}
	.link {
		display:flex; background:#FDB913; width:2em; height:2em; align-items:center; justify-content:center; border-radius:50%;
	}
	.link + .link {
		margin-left:.5em;
	}
	.sprite {
		fill:#fff; width:75%; height:auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/ShareTools/index.vue